// This file was auto-generated by Fern from our API Definition.
export const SimpleQueueKind = {
    Queries: "queries",
    Testsets: "testsets",
    Traces: "traces",
    Testcases: "testcases",
};
